import { ref, computed } from 'vue';

// Module-level singleton: persists while the app is running
const _copied = ref(null);

export function useStyleClipboard() {
    const hasCopied = computed(() => _copied.value !== null);

    const copyStyle = (style) => {
        _copied.value = JSON.parse(JSON.stringify(style));
    };

    const getCopied = () => _copied.value;

    return { hasCopied, copyStyle, getCopied };
}
